<template>
  <router-link
    v-if="to && to !== '#'"
    :to="to"
    class="menu-item"
    :class="[
      collapsed ? 'menu-item-collapsed' : '',
      isActive ? 'menu-item-active' : ''
    ]"
    :style="{ paddingLeft: collapsed ? '0' : (level * 14 + 12) + 'px' }"
    :title="collapsed ? title : ''"
    @click="$emit('click', $event)"
  >
    <Icon :icon="icon" width="18" height="18" class="menu-item-icon" />
    <span v-if="!collapsed" class="menu-item-title">{{ title }}</span>
  </router-link>

  <!-- Sin ruta → botón normal (para items sin navegación) -->
  <button
    v-else
    class="menu-item"
    :class="[
      collapsed ? 'menu-item-collapsed' : '',
      isActive ? 'menu-item-active' : ''
    ]"
    :style="{ paddingLeft: collapsed ? '0' : (level * 14 + 12) + 'px' }"
    :title="collapsed ? title : ''"
    @click="$emit('click', $event)"
  >
    <Icon :icon="icon" width="18" height="18" class="menu-item-icon" />
    <span v-if="!collapsed" class="menu-item-title">{{ title }}</span>
  </button>
</template>

<script>
import { Icon } from '@iconify/vue';

export default {
  name: 'MenuItem',
  components: { Icon },
  emits: ['click'],
  props: {
    to:       { type: String,  default: '#' },
    icon:     { type: String,  default: 'mdi:circle-small' },
    title:    { type: String,  required: true },
    collapsed:{ type: Boolean, default: false },
    isActive: { type: Boolean, default: false },
    level:    { type: Number,  default: 0 }
  }
};
</script>

<style scoped>
.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  text-decoration: none;
  cursor: pointer;
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  transition: background-color 0.15s, color 0.15s;
  touch-action: manipulation;
}

.menu-item:hover {
  background: #f3f4f6;
}

.menu-item-active {
  background: #eff6ff;
  color: #2563eb;
  font-weight: 600;
}

.dark .menu-item {
  color: #d1d5db;
}

.dark .menu-item:hover {
  background: #374151;
}

.dark .menu-item-active {
  background: rgba(37, 99, 235, 0.15);
  color: #60a5fa;
}

.menu-item-collapsed {
  justify-content: center;
  padding: 10px 0;
}

.menu-item-icon {
  flex-shrink: 0;
}

.menu-item-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}
</style>